import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyA39TayLMlJ9fLASQ9czyJ_ArN4ufO0KbA",
    authDomain: "slack-clone-be375.firebaseapp.com",
    projectId: "slack-clone-be375",
    storageBucket: "slack-clone-be375.appspot.com",
    messagingSenderId: "641024201179",
    appId: "1:641024201179:web:e6739a72f31aed3f8617fe"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { app, auth, provider, db };